'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isNull(x) {
    return x === null;
}
exports.isNull = isNull;
